import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface CopyDepartmentRequest {
  name: string;
  copyGLCodes: boolean;
  copyMembers: boolean;
  copyDeletedGLCodes: boolean;
  copyDeletedMembers: boolean;
}

const usePostDepartmentCopyApi = (companyId: number, departmentId: number) => {
  const call = useCallback(
    async (body?: CopyDepartmentRequest) =>
      axiosInstance.post(api.copyDepartment(companyId, departmentId), body),
    [companyId, departmentId]
  );

  const { isLoading, execute } = useAsync(call, false, undefined);

  return {
    isLoading,
    addCopyDepartment: execute,
  };
};

export default usePostDepartmentCopyApi;
